export default __webpack_public_path__ + "162a563c02ec232a1419dd4df8dcbf0d.png";